'use client';
import { posthog } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import React from 'react';

export function Provider({ children }: { children: React.ReactNode }) {
  React.useEffect(() => {
    let requestID: number;
    const initPostHog = () => {
      if (typeof window !== 'undefined' && !posthog.__loaded) {
        posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
          api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
        });
      }
    };

    if ('requestIdleCallback' in window) {
      requestID = window.requestIdleCallback(initPostHog);
    } else {
      // Fallback for browsers that don't support requestIdleCallback
      setTimeout(initPostHog, 1);
    }

    return () => {
      if ('cancelIdleCallback' in window) {
        window.cancelIdleCallback(requestID);
      }
    };
  }, []);

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
